import cn from 'clsx';
import React from 'react';

import { Heading1, Image, useDeviceType } from '@cian/ui-kit';
import { ETestIds } from 'shared/constants/testIds';
import { useIsDarkTheme } from 'shared/hooks/common';
import { IBankPartner } from 'shared/selectors/dictionaries/selectBankPartners';

import { NBSP } from 'shared/constants/common';
import styles from './styles.css';

export interface IBankPartnersBlockProps {
  bankPartners: IBankPartner[];
}

function getBankPartnerLogoUrl(
  { wideLogoUrlLight, wideLogoUrlDark }: IBankPartner,
  isDarkTheme: boolean,
): string | null {
  if (isDarkTheme) {
    return wideLogoUrlDark ?? wideLogoUrlLight ?? null;
  }

  return wideLogoUrlLight ?? wideLogoUrlDark ?? null;
}

export const BankPartnersBlock: React.FC<IBankPartnersBlockProps> = ({ bankPartners }) => {
  const deviceType = useDeviceType();
  const isDarkTheme = useIsDarkTheme();

  return (
    <div className={cn(styles['root'], styles[deviceType])} data-testid={ETestIds.BankPartnersBlock}>
      <div className={cn(styles['title'], styles[deviceType])}>
        <Heading1 fontWeight="700">
          Работаем с{NBSP}проверенными{NBSP}банками
        </Heading1>
      </div>
      <ul className={cn(styles['grid'], styles[deviceType])}>
        {bankPartners.map(partner => {
          const logoUrl = getBankPartnerLogoUrl(partner, isDarkTheme);

          if (!logoUrl) {
            return null;
          }

          return (
            <li
              key={partner.id}
              className={cn(styles['card'], styles[deviceType])}
              data-testid={`${ETestIds.BankPartnerCard} bankId-${partner.id}`}
            >
              <span className={styles['logo']}>
                <Image src={logoUrl} alt={partner.title} objectFit="contain" preloader width="100%" height="100%" />
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
